(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var display = g.querySelector('[data-gallery-display]');
    var thumbs = g.querySelectorAll('[data-gallery-thumb]');
    if (!display || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        var src = t.getAttribute('data-full');
        if (!src) return;
        display.style.opacity = '0';
        var img = new Image();
        img.onload = function () {
          display.src = src;
          display.style.opacity = '1';
        };
        img.src = src;
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        t.blur();
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
